module.exports = __webpack_public_path__ + "img/download.af98d6fe.svg";